<template>
  <Card
    :class="classObject"
    class="DealPriceCard"
  >
    <el-tooltip
      :content="$t('priceCardTooltip')"
      placement="top"
      class="Tooltip"
      effect="dark"
    >
      <div class="DealPriceCard__value">
        {{ priceValue | formatNumber }} {{ currency }}
      </div>
    </el-tooltip>
    <el-tooltip
      :content="$t('priceCardLabelTooltip')"
      placement="left-end"
      class="Tooltip"
      effect="dark"
    >
      <div class="DealPriceCard__label">{{ label | formatNumber }} c&euro;/kWh </div>
    </el-tooltip>
  </Card>
</template>

<script>
import Card from '@/components/Card.vue';
import Tooltip from '@/components/Tooltip.vue';

export default {
  name: 'DealPriceCard',
  components: {
    Card,
    Tooltip,
  },
  props: {
    cardType: {
      type: String,
      required: true,
      validator: value =>
        // The value must match one of these strings
        ['total'].indexOf(value) !== -1
      ,
    },
    priceValue: {
      type: Number,
      default: 0,
      required: true,
    },
    currency: {
      type: String,
      default: '',
      required: true,
    },
    label: {
      type: Number,
      default: null,
      required: true,
    },
  },
  computed: {
    classObject() {
      return {
        'DealPriceCard--total': this.cardType === 'total',
      };
    },
  },
};
</script>

<style scoped lang="scss">
.DealPriceCard {
  overflow: hidden;
}
.DealPriceCard /deep/ .container-fluid {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.DealPriceCard__label {
  font-size: 14px;
  margin-top: 12px;
}
.DealPriceCard--total {
  background-color: $color--secondary;

  .DealPriceCard__value {
    @include roboto500;
    font-size: 24px;
    color: #fff;
  }
  .DealPriceCard__currency {
    @include roboto500;
    font-size: 16px;
    color: #fff;
  }
  .DealPriceCard__label {
    color: #fff;
  }
}
</style>
